<p-dataview #dv [value]="listings() || loadingSkeletons()" lazy="true" [layout]="layout()"
    [paginator]="showPagination() && listings().length > 0" [first]="first()" [rows]="pageSize()" [totalRecords]="totalRecords()"
    [showCurrentPageReport]="true" [showPageLinks]="false" [showJumpToPageDropdown]="false"
    currentPageReportTemplate="{first} - {last} от {totalRecords}" (onPage)="onPageChange($event)"
    paginatorStyleClass="flex justify-center md:!justify-end" [emptyMessage]="''">
    @if(showSorting()){
    <ng-template #header>
        <div class="flex justify-end items-center py-4 px-0 md:p-4" [ngClass]="headerContainerClass()">
            <ng-container [ngTemplateOutlet]="headerExtraTemplate"></ng-container>
            <p-iftalabel class="min-w-[150px] lg:w-56">
                <p-select [ngModel]="sortBy()" (onChange)="onSortByChange($event.value)" inputId="sortBy"
                    [options]="sortByOptions()" styleClass="w-full" />
                <label for="sortBy">Сортирай по</label>
            </p-iftalabel>
        </div>
    </ng-template>
    }
    <ng-template #list let-listings>
        @let listingsCount = listings.length;
        <div class="flex flex-col gap-4 py-2 md:py-0">
            @if(loading()) {
            @for (listing of loadingSkeletons(); track $index) {
            <ng-container [ngTemplateOutlet]="listingLoadingTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{index: $index}"></ng-container>
            }
            }@else {
            @for (listing of listings; track $index) {
            <ng-container [ngTemplateOutlet]="listingTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{$implicit: listing,index: $index}"></ng-container>
            @if(listingsCount>($index+1)){
            <hr class="border border-lightGreen" />
            }
            }
            }
        </div>
    </ng-template>
    <ng-template #grid let-listings>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            @if(loading()) {
            @for (listing of loadingSkeletons(); track $index) {
            <ng-container [ngTemplateOutlet]="listingLoadingTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{index: $index}"></ng-container>
            }
            }@else {
            @for (listing of listings; track $index) {
            <ng-container [ngTemplateOutlet]="listingTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{$implicit: listing,index: $index}"></ng-container>
            }
            }
        </div>
    </ng-template>
    <ng-template #emptymessage>
        <div class="flex justify-center items-center py-2 gap-4 min-h-[200px] md:min-h-[100px]">
            <h3 class="text-xl font-bold">Няма намерени обяви</h3>
            <img src="assets/no-listings-icon.svg" alt="No bike icon" class="w-8 h-8" />
        </div>
    </ng-template>
</p-dataview>


<ng-template #defaultTemplate let-option>
    <div>No template</div>
</ng-template>